import FormData from "form-data";

import { baseService } from "./base";

class ApplicationService {
  // This endpoint returns all applications available to the user's account.
  load() {
    return baseService.get("/api/applications");
  }

  loadAll() {
    return baseService.get("/api/applications/all");
  }

  edit(appId, op, status, versionId = null) {
    const data = {
      op,
      status,
    };

    if (versionId) {
      data.version_id = versionId;
    }

    return baseService.put(`/api/application/${appId}`, data);
  }

  upload(file) {
    const data = new FormData();

    data.append("file", file);

    return baseService.post("/api/application", data, "form");
  }
}

const applicationService = new ApplicationService();

export { applicationService };
